import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatLocalizedDateTime } from '../utils/i18nFormatters';

export const isValidWaterQualityReading = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0;
};

const WaterQualityReadingCard = ({ label, value, unit, measuredAt, isOffline, icon, valueClassName = 'text-white' }) => {
  const { t, i18n } = useTranslation();
  const hasValue = isValidWaterQualityReading(value);
  const time = measuredAt
    ? formatLocalizedDateTime(measuredAt, i18n.language)
    : t('unitDetail.sensors.timeUnknown');

  return (
    <div className="admin-muted-panel flex items-start justify-between gap-3 rounded-2xl p-4">
      <div className="flex min-w-0 items-center gap-3">
        {icon}
        <span className="admin-text-primary text-sm font-bold">{label}</span>
      </div>
      <div className="min-w-0 text-right">
        {hasValue ? (
          <p className={`text-2xl font-black ${valueClassName}`}>
            {value}
            {unit ? <small className="ml-1 text-[10px] opacity-60">{unit}</small> : null}
          </p>
        ) : (
          <p className="admin-text-muted text-lg font-black">--</p>
        )}
        <p className={`mt-1 leading-relaxed ${hasValue ? 'text-[10px] admin-text-secondary' : 'text-xs font-bold text-[var(--admin-warning)]'}`}>
          {hasValue
            ? t(isOffline ? 'unitDetail.sensors.lastValidAt' : 'unitDetail.sensors.latestValidAt', { time })
            : t('unitDetail.sensors.noHistory')}
        </p>
      </div>
    </div>
  );
};

export default WaterQualityReadingCard;
